import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedUiKitModule } from '@realwear-cloud/shared/ui-kit';
import { ShareUrlButtonComponent } from './share-url-button/share-url-button.component';
import { SidemenuComponent } from './sidemenu/sidemenu.component';
import { ThemeSwitcherComponent } from './theme-switcher/theme-switcher.component';
import { TopbarComponent } from './topbar/topbar.component';

@NgModule({
  declarations: [TopbarComponent, SidemenuComponent, ShareUrlButtonComponent, ThemeSwitcherComponent],
  imports: [CommonModule, FontAwesomeModule, MatIconModule, SharedUiKitModule],
  exports: [TopbarComponent, SidemenuComponent, ShareUrlButtonComponent, ThemeSwitcherComponent]
})
export class SharedUIModule {}
